import { useEffect } from 'react'
import {
  fetchDynamicFieldsByEntitySales,
  fetchDynamicFieldsByEntitySalesDetail,
} from 'src/actions/dynamicfield.actions'
import { useDispatch, useSelector } from 'react-redux'
import {
  selectEntitySalesDetailFields,
  selectEntitySalesFields,
} from 'src/selectors/dynamicFields.selector'
import { useDynamicFields } from 'src/components/CompanyDynamicFields/hook/useDynamicFields'

export const useSaleDynamicFields = (
  withValues?: DynamicFieldRequest[],
  detail?: boolean,
) => {
  const dispatch = useDispatch()
  const entityFields = useSelector(
    detail ? selectEntitySalesDetailFields : selectEntitySalesFields,
  )

  useEffect(() => {
    dispatch(
      detail
        ? fetchDynamicFieldsByEntitySalesDetail()
        : fetchDynamicFieldsByEntitySales(),
    )
  }, [detail])

  return useDynamicFields(entityFields, withValues)
}
